// import 'twin.macro';

// const RestTimerCircle = ({ timer, convertOn, large = false }) => {
//   const progress = (timer - 1) / convertOn;
//   const elapsed = (1 - progress) * 360;

//   const startX = 50 + 45 * Math.sin((elapsed * Math.PI) / 180);
//   const startY = 50 - 45 * Math.cos((elapsed * Math.PI) / 180);
//   const remainingDeg = 360 - elapsed;
//   const largeArcFlag = remainingDeg > 180 ? 1 : 0;

//   const pathData =
//     elapsed <= 0
//       ? 'M50,5 A45,45 0 1,1 50,95 A45,45 0 1,1 50,5'
//       : elapsed >= 360
//         ? ''
//         : `M50,50 L${startX},${startY} A45,45 0 ${largeArcFlag} 1 50,5 Z`;

//   if (large) {
//     const displaySeconds = Math.ceil(timer / 1000);

//     return (
//       <div
//         style={{
//           width: 220,
//           height: 220,
//           borderRadius: '50%',
//           border: '9px solid white',
//           boxShadow: '0px 0px 25px 0px rgba(0,0,0,0.75)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           position: 'relative',
//           overflow: 'hidden',
//           backgroundColor: 'rgba(39,39,39,0.9)',
//         }}
//       >
//         <svg
//           width="202"
//           height="202"
//           viewBox="0 0 100 100"
//           style={{ position: 'absolute', inset: 0 }}
//         >
//           <circle cx="50" cy="50" r="50" fill="rgba(150,150,150,0.35)" />
//         </svg>
//         <span
//           style={{
//             position: 'relative',
//             color: '#ffffff',
//             fontSize: 80,
//             fontWeight: 900,
//             lineHeight: 1,
//             zIndex: 1,
//             fontFamily: 'Roboto, sans-serif',
//           }}
//         >
//           {displaySeconds > 0 ? displaySeconds : 0}
//         </span>
//       </div>
//     );
//   }

//   return (
//     <div tw="border-[2px] border-[#8DA12B] rounded-full">
//       <svg width="60" height="60" viewBox="0 0 100 100">
//         <path d={pathData} fill="#8DA12B" />
//         <text
//           x="50"
//           y="50"
//           textAnchor="middle"
//           dominantBaseline="central"
//           fill="#475016"
//           fontSize="45"
//           fontWeight="900"
//           tw="[font-family: Roboto, sans-serif]"
//         >
//           {Math.ceil(timer || 5)}
//         </text>
//       </svg>
//     </div>
//   );
// };

// export default RestTimerCircle;

import 'twin.macro';

const RestTimerCircle = ({ timer, convertOn, large = false }) => {
  const numericTimer = Number(timer);
  const numericDefault = Number(convertOn);
  const displayValue = Number.isFinite(numericTimer)
    ? Math.max(0, numericTimer)
    : Number.isFinite(numericDefault)
      ? Math.max(0, numericDefault)
      : 5;

  if (large) {
    const displaySeconds = Math.ceil(displayValue / 1000);

    return (
      <div
        style={{
          width: 220,
          height: 220,
          borderRadius: '50%',
          border: '9px solid white',
          boxShadow: '0px 0px 25px 0px rgba(0,0,0,0.75)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: 'rgba(39,39,39,0.9)',
        }}
        data-testid="timer"
      >
        <svg
          width="202"
          height="202"
          viewBox="0 0 100 100"
          style={{ position: 'absolute', inset: 0 }}
        >
          <circle cx="50" cy="50" r="50" fill="rgba(150,150,150,0.35)" />
        </svg>

        <span
          style={{
            position: 'relative',
            color: '#ffffff',
            fontSize: 80,
            fontWeight: 900,
            lineHeight: 1,
            zIndex: 1,
            fontFamily: 'Roboto, sans-serif',
          }}
        >
          {displaySeconds > 0 ? displaySeconds : 0}
        </span>
      </div>
    );
  }

  return (
    <div tw="border-[2px] border-[#8DA12B] rounded-full" data-testid="timer">
      <svg width="60" height="60" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" fill="#8DA12B" />

        <text
          x="50"
          y="50"
          textAnchor="middle"
          dominantBaseline="central"
          fill="#475016"
          fontSize="45"
          fontWeight="900"
          tw="[font-family: Roboto, sans-serif]"
        >
          {Math.ceil(displayValue)}
        </text>
      </svg>
    </div>
  );
};

export default RestTimerCircle;
